import { render, staticRenderFns } from "./MandateForm.vue?vue&type=template&id=150b57f2"
import script from "./MandateForm.vue?vue&type=script&lang=ts"
export * from "./MandateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports